export let isInitialized = false;
export let history;
export let Route;
export function setReactRouterV4V5Dependencies(dependencies) {
    isInitialized = true;
    history = dependencies.history;
    Route = dependencies.Route;
}
export function setReactRouterV4V5SSRDependencies(newDependencies) {
    Route = newDependencies.Route;
}
//# sourceMappingURL=routerDependencies.js.map